import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { NavigationStart, Router } from "@angular/router";
import { GoogleAnalyticsService } from "src/app/services/google-analytics.service";

@Injectable({
  providedIn: "root",
})
export class SeoService {
  // tslint:disable-next-line: variable-name
  // page_title = new Subject<string>();

  constructor(
    private titleService: Title,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  updatePageTitle(title: string) {
    // this.titleService.setTitle(title);
    // this.page_title.next(title);

    // tslint:disable-next-line: no-shadowed-variable
    // this.googleAnalyticsService.startTrackerWithId("UA-135312590-2");
    // this.googleAnalyticsService.trackView(
    //   this.router.url,
    //   "Travelx ai - " + title
    // );
    // await this.router.events
    //   .subscribe(event => {
    //     // observe router and when it start navigation it will track the view
    //     if (event instanceof NavigationStart) {
    //       // tslint:disable-next-line: no-shadowed-variable
    //       // let title = this.titleService.getTitle();
    //       // get title if it was sent on state
    //       // if (this.router.getCurrentNavigation().extras.state) {
    //       //   title = this.router.getCurrentNavigation().extras.state.title;
    //       // }
    //       // pass url and page title
    //       console.log('in ga code : '+ title);
    //     }
    //   });
  }
}
